
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kapcsolat",
      function () {
        return require("private-next-pages/kapcsolat/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kapcsolat"])
      });
    }
  